export default __webpack_public_path__ + "static/media/graxalta_GxD_jpg_webdesign2021_productillustrations_lacteos_02.3e82eadb.jpg";